import React, { useState, useCallback } from 'react'
import CssBaseline from '@mui/material/CssBaseline'
import ReactDOM from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import './styles/shared-styles.scss'
import { ThemeProvider } from '@mui/material/styles'
import Dialog from '@mui/material/Dialog'
import { HelmetProvider } from 'react-helmet-async'
import { useMediaQuery } from '@mui/material'
import * as Sentry from '@sentry/react'
import App from './App'
import reportWebVitals from './reportWebVitals'
import themeImport from './theme'
import { handleDismiss } from './utils/appInstallUtils'
import useVersionCheck from './hooks/useVersionCheck'
import useAppInstall from './hooks/useAppInstall'
import InstallPromptSnackbar from './components/common/InstallPromptSnackbar/index'
import AppUpdateSnackbar from './components/common/AppUpdateSnackbar/index'
import ScrollTop from './components/common/ScrollTop/index'
import { initialiseGTM } from './utils/GTMPlugin'

initialiseGTM()

Sentry.init({
	dsn: 'https://a318e13605a882c1e2b9db3bed00a9d9@o15468.ingest.us.sentry.io/4508648430764032',
	integrations: []
})

const AppInstallComponent = ({
	isInstallPromptVisible,
	handleInstall,
	setIsInstallPromptVisible,
	theme
}) => {
	const isMobileOrTablet = useMediaQuery(() => theme.breakpoints.down('md'))

	return (
		<Dialog open={isInstallPromptVisible && isMobileOrTablet}>
			<InstallPromptSnackbar
				isVisible={isInstallPromptVisible && isMobileOrTablet}
				onInstall={handleInstall}
				onDismiss={() => handleDismiss(setIsInstallPromptVisible)}
				theme={theme}
			/>
		</Dialog>
	)
}

const RootComponent = () => {
	const [isUpdateAvailable, setIsUpdateAvailable] = useState(false)
	const [deferredPrompt, setDeferredPrompt] = useState(null)
	const [isInstallPromptVisible, setIsInstallPromptVisible] = useState(false)

	const handleInstall = useCallback(async () => {
		if (deferredPrompt) {
			deferredPrompt.prompt()
			const { outcome } = await deferredPrompt.userChoice
			console.log(`User choice: ${outcome}`)
			setDeferredPrompt(null)
			setIsInstallPromptVisible(false)
		}
	}, [deferredPrompt])

	const handleUpdate = useCallback(() => {
		window.location.reload()
	}, [])

	useVersionCheck(setIsUpdateAvailable)
	useAppInstall({ setIsInstallPromptVisible, setDeferredPrompt })

	return (
		<ThemeProvider theme={themeImport}>
			{/* <React.StrictMode> @todo re-enable this is for demo */}
			<Router>
				<ScrollTop />
				<CssBaseline />
				<HelmetProvider>
					<App />
				</HelmetProvider>
				<AppInstallComponent
					isInstallPromptVisible={isInstallPromptVisible}
					theme={themeImport}
					handleInstall={() => handleInstall()}
					setIsInstallPromptVisible={() => setIsInstallPromptVisible()}
				/>
				<Dialog open={isUpdateAvailable}>
					<AppUpdateSnackbar
						isVisible={isUpdateAvailable}
						onUpdate={handleUpdate}
						onDismiss={() => setIsUpdateAvailable(false)}
						theme={themeImport}
					/>
				</Dialog>
			</Router>
			{/* </React.StrictMode> */}
		</ThemeProvider>
	)
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<RootComponent />)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
